export class DesignSystemCollection {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // Constructor
    constructor(model) {
        var _a, _b, _c, _d, _e, _f;
        this.id = model.id;
        this.designSystemVersionId = model.designSystemVersionId;
        this.persistentId = model.persistentId;
        this.name = model.meta.name;
        this.description = (_a = model.meta.description) !== null && _a !== void 0 ? _a : "";
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.updatedAt = model.updatedAt ? new Date(model.updatedAt) : null;
        this.originId = (_c = (_b = model.origin) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : null;
        this.originSourceIds = (_e = (_d = model.origin) === null || _d === void 0 ? void 0 : _d.sourceIds) !== null && _e !== void 0 ? _e : [];
        this.parentPersistentId = (_f = model.parentPersistentId) !== null && _f !== void 0 ? _f : null;
    }
}
